(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["diamond-shapes-slider"] && !Shopify.designMode) return;
  try {
    
var swiper = new Swiper('.diamond-swiper', {
  slidesPerView: 5,
  spaceBetween: 30,
  centeredSlides: true,
  loop: true,
  navigation: true,
  on: {
    slideChange: function () {
      updateDiamondInfo(this);
    },
    init: function () {
      updateDiamondInfo(this);
    }
  },
  breakpoints: {
    320: { 
        slidesPerView: 2,
        spaceBetween: 5
    },
    576: { 
        slidesPerView: 3 
    },
    768: { 
        slidesPerView: 3 
    },
    992: { 
        slidesPerView: 5 
    }
    },
});
function updateDiamondInfo(swiper) {
  var activeSlide = swiper.slides[swiper.activeIndex];
  if (activeSlide) {
    document.querySelector(".diamond-style").textContent = activeSlide.dataset.style;
  }
}

  } catch(e) { console.error(e); }
})();
})();
